import { F } from '@angular/cdk/keycodes';
import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, LossReasonService } from 'lib-trend-core';
import { finalize, takeUntil } from 'rxjs';

@Component({
    selector: 'app-loss-reason-form-modal',
    templateUrl: './loss-reason-form-modal.component.html',
    styleUrl: './loss-reason-form-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LossReasonFormModalComponent extends AbstractComponent {

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<LossReasonFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private lossReasonService: LossReasonService,
  ) {
    super(injector);
    this.setupForm();
  }


  ngOnInit(): void {
    this.isNew = !this.data;
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [this.data ? this.data.name : '', [Validators.required]],
      description: [this.data ? this.data.description : '', []],
    });
  }

  save(): void {
    this.loading = true;
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    }

    const lossReason = {
      ...this.data,
      ...this.formGroup.value,
      company: super.getCompanyCurrentUser(),
    };

    const saveObservable = this.isNew
      ? this.lossReasonService.create(lossReason)
      : this.lossReasonService.update(lossReason._id, lossReason);

    saveObservable
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (response) => {
          this.alertService.success(this.t('kanban.lossReasonFormModal.saveSuccess', { action: this.t(this.isNew ? 'kanban.lossReasonFormModal.actionCreated' : 'kanban.lossReasonFormModal.actionUpdated') }));
          this.dialogRef.close(response);
        },
        error: (error) => {
          this.alertService.error(this.t('kanban.lossReasonFormModal.saveError'));
        }
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
